<template>
	<div class="sscw-container sscw-flex-column">
		<h2 id="top" class="sscw-step-title">
			{{ wizardContent.step3_header ? wizardContent.step3_header : "step3_header" }}
		</h2>
		<h3 class="step-description">
			{{ wizardContent.step3_Description ? wizardContent.step3_Description : "step3_Description" }}
		</h3>

		<div class="step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.wertIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.wertIcon" width="42px" alt="icon" />
				</div>
				<div class="sscw-w-full">
					<div class="sscw-step-input sscw-container">
						<div class="sscw-step-input-content">
							<div class="flex-col">
								<div class="flex-row">
									<div class="label-row">
										<div class="sscw-step-input-description">
											<div>
												{{
													wizardContent.step3_houseValue_label
														? wizardContent.step3_houseValue_label
														: "step3_houseValue_label"
												}}
											</div>
											<Tooltip
												:htmlText="
													wizardContent.step3_houseValue_tooltip
														? wizardContent.step3_houseValue_tooltip
														: 'step3_houseValue_tooltip'
												"
											/>
										</div>
									</div>
									<div class="sscw-step-input-box">
										<input
											v-model="appraisalValueFormat"
											ref="appraisalValueInput"
											type="text"
											class="sscw-input"
											@blur="handleAppraisalValueValidation"
											@change="handleAppraisalValueValidation"
											placeholder="0"
										/>
										<div class="sscw-input-suffix">€</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="sscw-container flex">
						<div class="sscw-slider-container">
							<input
								type="range"
								v-model="appraisalValue"
								:min="appraisalValueOptions.min"
								:max="appraisalValueOptions.max"
								:step="appraisalValueOptions.interval"
								@change="handleAppraisalValueValidation"
							/>
						</div>

						<div class="sscw-slider-range-container">
							<div class="sscw-slider-range-label">keine Angabe</div>
							<div class="sscw-slider-range-label">€ 5.000.000</div>
						</div>

						<div class="checkbox-row">
							<input class="checkbox-input" v-model="existEncumbrances" id="isEditable" type="checkbox" />

							<label class="checkbox-label" for="isEditable">
								{{
									wizardContent.step2_encumbrances_label
										? wizardContent.step2_encumbrances_label
										: "step2_encumbrances_label"
								}}
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>

		
	</div>
</template>

<script>
import Tooltip from "@/components/shared/Tooltip.vue";
import wizardContent from "@/utils/extnWizardContent";
import getTheme from "@/utils/theme";

export default {
	name: "ClickWizardStep1",
	components: { Tooltip },

	data() {
		return {
			theme: getTheme(),
			wizardContent: wizardContent(),
			userHasInteracted: false,
			initialPayoutOptions: {},
			appraisalValueOptions: {
				min: 0,
				max: 5000000,
				interval: 10000,
				dotSize: 22,
				height: 4,
				width: "auto",
				direction: "ltr",
				data: null,
				dataLabel: "label",
				dataValue: "value",
				clickable: true,
				duration: 0.5,
				dotStyle: {
					"background-color": "#112C42",
				},
				processStyle: {
					"background-color": "#112C42",
				},
			},
		};
	},
	created() {
		this.initialPayoutOptions = {
			min: this.appraisalValue * 0.2,
			max: this.appraisalValue * 0.6,
			interval: 1,
		};
	},
	computed: {
		isAppraisalValueValid: {
			get() {
				return this.$store.wizardState.isAppraisalValueValid;
			},
			set(value) {
				this.$store.wizardState.isAppraisalValueValid = value;
				this.$emit("onValidation", this.validateStep());
			},
		},
		existEncumbrances: {
			get() {
				return this.$store.wizardState.exitEncumbrances;
			},
			set(newValue) {
				this.$store.wizardState.exitEncumbrances = newValue;
			},
		},
		appraisalValue: {
			get() {
				return this.$store.wizardState.appraisalValue;
			},
			set(newValue) {
				if (newValue < this.appraisalValueOptions.min) {
					this.$store.wizardState.appraisalValue = this.appraisalValueOptions.min;
				} else if (newValue > this.appraisalValueOptions.max) {
					this.$refs.appraisalValueInput.value = this.appraisalValueOptions.max;
					this.$store.wizardState.appraisalValue = this.appraisalValueOptions.max;
				} else if (newValue !== null) {
					this.$store.wizardState.appraisalValue = newValue;
				}
				this.initialPayoutOptions = {
					min: this.appraisalValue * 0.2,
					max: this.appraisalValue * 0.6,
					interval: 1,
				};
			},
		},
		appraisalValueFormat: {
			get() {
				return this.displayInCurrency(this.appraisalValue);
			},
			set(newValue) {
				if(isNaN(newValue)){
					return this.$refs.appraisalValueInput.value = newValue.replaceAll(/[^0-9]/g, "");
				}
				const onlyNumber = newValue.replaceAll(/[^0-9]/g, "");
				this.appraisalValue = parseInt(onlyNumber || "0");
			},
		},
		initialPayout: {
			get() {
				return this.$store.wizardState.initialPayout;
			},
			set(value) {
				if (value < this.initialPayoutOptions.min) {
					this.$store.wizardState.initialPayout = this.initialPayoutOptions.min;
				} else if (value > this.initialPayoutOptions.max) {
					this.$store.wizardState.initialPayout = this.initialPayoutOptions.max;
				} else if (value !== null) {
					this.$store.wizardState.initialPayout = value;
				}
			},
		},
		initialPayoutFormat: {
			get() {
				return this.initialPayout ? this.displayInCurrency(this.initialPayout) : "";
			},
			set(newValue) {
				const onlyNumber = newValue.replaceAll(/[^0-9]/g, "");
				this.initialPayout = parseInt(onlyNumber || "0");
			},
		},
		isInitialPayoutValid: {
			get() {
				return this.$store.wizardState.isInitialPayoutValid;
			},
			set(value) {
				this.$store.wizardState.isInitialPayoutValid = value;
				this.$emit("onValidation", this.validateStep());
			},
		},
	},
	mounted() {
		this.$emit("onValidation", true);

		this.$nextTick(() => {
			document
				.querySelector("#shortcode-2-977 > ss-lebenswert-wizard-extn")
				?.shadowRoot.querySelector("#top")
				?.scrollIntoView();
			window.scrollTo(0, -150);
		});
	},
	methods: {
		displayInCurrency(v) {
			return `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
		},
		emitUpdate() {
			this.$emit("updated", {
				appraisalValue: this.appraisalValue,
			});
		},
		validateStep() {
			if (this.isAppraisalValueValid ) {
				return true;
			}
			if (!this.userHasInteracted) {
				return false;
			}
			return this.isAppraisalValueValid ? true : false;
		},
		appraisalValueValidation(inputData) {
			if (inputData >= 0) {
				return (this.isAppraisalValueValid = true);
			}
			return (this.isAppraisalValueValid = false);
		},
		handleAppraisalValueValidation(event) {
			this.handleUserInteraction();
			if(this.appraisalValueOptions.min<event.target.value){
				this.$refs.appraisalValueInput.value =  this.displayInCurrency(this.appraisalValue);
			}
			
			/*else{
				this.$refs.appraisalValueInput.value = "keine Angabe"
			}*/
			
			this.appraisalValueValidation(event.target.value);
		},
		handleAppraisalValueSliderChange(value) {
			this.appraisalValueValidation(value);
		},
		handleUserInteraction() {
			this.userHasInteracted = true;
			this.$emit("onValidation", this.validateStep());
		},
		initialPayoutValidation(inputData) {
			if (inputData >= 0) {
				return (this.isInitialPayoutValid = true);
			}
			return (this.isInitialPayoutValid = false);
		},
		handleInitialPayoutValidation(event) {
			this.$refs.initialPayoutInput.value = this.displayInCurrency(this.initialPayout);
			this.initialPayoutValidation(event.target.value);
		},
		handleInitialPayoutSliderChange(value) {
			this.initialPayoutValidation(value);
		},
	},
};
</script>
<style scoped>
.step-description {
	margin: unset;
}

.jump-to-top {
	visibility: hidden;
}

.step-image-group {
	display: flex;
	gap: 34px;
	align-items: center;
}

.checkbox-row {
	margin-top: 22px;
	display: flex;
	gap: 12px;
	align-items: center;
}

.checkbox-label {
	font-family: Inter;
	font-size: 14px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0em;
	text-align: left;
}

.default-input-value {
	font-family: Inter;
	font-size: 32px;
	font-weight: 400;
	line-height: 41px;
	letter-spacing: 0em;
	text-align: left;
	display: block;
	margin-top: 16px;
	margin-left: auto;
	margin-right: auto;
	width: fit-content;
}

.checkbox-input {
	cursor: pointer;
	accent-color: #112c42;
	width: 18px;
	height: 18px;
}

.flex-col {
	display: flex;
	flex-direction: column;
}

.sscw-flex-column {
	gap: 24px;
	display: flex;
	flex-direction: column;
}

.sscw-step-input-group {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 6px;
}

.sscw-step-input-description {
	display: flex;
	align-items: center;
}

.mobile-img {
	margin-left: 14px;
}

.sscw-w-full {
	flex: 1;
}

@media (min-width: 1190px) {
	.sscw-step-input-group {
		width: 683px;
		padding: 33px 0;
	}

	.flex-row {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.flex-col {
		width: 100%;
	}

	.label-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.default-input-value {
		margin-top: 0;
		margin-left: unset;
		margin-right: unset;
		width: fit-content;
	}
}
</style>
